import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import AboutRelationship from '../AboutRelationship/AboutRelationship';
import CharityRegNumber from '../CharityRegNumber/CharityRegNumber';
import PageListMini from '../PageList/PageListMini';
import PageSection from '../PageSection/PageSection';

interface CampaignMini {
  totalCount: number;
  campaigns: {
    id: string;
    title: string;
    logo?: string | null;
    summary?: string | null;
    url: string;
    branding?: {
      logo: string | null;
    };
  }[];
  charityShortName?: string;
  charityName?: string;
}

const AboutCampaignMini: FunctionComponent<CampaignMini> = ({
  totalCount,
  campaigns,
  charityName,
  charityShortName,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  if (totalCount === 1) {
    const [{ url, logo, title, summary, branding }] = campaigns;
    return (
      <>
        <AboutRelationship
          landingPageUrl={url}
          logo={branding?.logo ?? logo}
          name={title}
          description={summary}
          parentPageUrl={charityShortName ? `/${charityShortName}` : undefined}
          parentName={charityName}
          inline
        >
          <CharityRegNumber className="jg-space-mbn" />
        </AboutRelationship>
      </>
    );
  }

  return (
    <PageSection
      title={t('page.campaignMiniTitle')}
      className="jg-pages-aboutownermini"
      count={totalCount}
    >
      <PageListMini pages={campaigns} totalCount={totalCount} />
    </PageSection>
  );
};

export default AboutCampaignMini;
